// src/marketing/editorial/Chip.tsx
import { JSX, ReactNode } from 'react'

type Props = {
  children: ReactNode
  variant?: 'date' | 'ref' | 'default'
}

// Mapping variant → classes CSS (editorial.css)
// .chip.cdate  — date
// .chip.cref   — ref (CSS cible a.chip.cref mais on applique sur <span> — mismatch mineur noté)
// .chip        — default (pas de modificateur)
function variantClass(variant: Props['variant']): string {
  switch (variant) {
    case 'date': return 'chip cdate'
    case 'ref':  return 'chip cref'
    default:     return 'chip'
  }
}

export function Chip({ children, variant }: Props): JSX.Element {
  return <span className={variantClass(variant)}>{children}</span>
}
